import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { authToken } from '../../scripts/authentication.script';

export class DocumentEmailDA {
  static apiResponse: ApiResponse

  public static async sendEmail(
    id_company: string,
    documentType: string,
    id_document: string,
    to: string,
    subject: string,
    message: string,
    company_email: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/${documentType}/${id_document}/send-email`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    let data: any = { to, subject, message, company_email }

    await axios.post(url, data, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }
}
